// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.11722 0H16.8828L17.3859 4.02458C18.8605 4.21393 20 5.47389 20 7V9H21V15H20V17C20 18.5261 18.8605 19.7861 17.3859 19.9754L16.8828 24H7.11722L6.61414 19.9754C5.13954 19.7861 4 18.5261 4 17V7C4 5.47389 5.13954 4.21393 6.61414 4.02458L7.11722 0ZM7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18Z"}}]};

const WatchFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'watch-filled',
    ref,
    icon: element,
  },
));

WatchFilledIcon.displayName = 'WatchFilledIcon';

export default WatchFilledIcon;
